// const productionURL = 'https://testdadi18.ccicftech.com'
//
// export const apiUrl = process.env.NODE_ENV === 'development' ? devURl : productionURL

//export const apiUrl = window.location.origin.indexOf("localhost") > -1?'https://testdadi18.ccicftech.com':window.location.origin

export const getApiUrl = () => window.location.origin